<template>
  <div class="tags-wrapper">
    <div class="header-controls">
      <div class="left">
        <input type="checkbox" @change="handleCheckAll" />
        <div class="tagname-wrap">
          <span class="tag-name"> Tag Name </span>
          <div class="arrows">
            <span class="material-icons"> arrow_drop_up </span>
            <span class="material-icons"> arrow_drop_down </span>
          </div>
        </div>
      </div>
      <div class="right">
        <!-- <div class="count-wrap">
          <span class="count"> Count </span>
          <div class="arrows">
            <span class="material-icons"> arrow_drop_up </span>
            <span class="material-icons"> arrow_drop_down </span>
          </div>
        </div> -->
        <div class="actions-wrap">
          <span class="actions"> Actions </span>
        </div>
      </div>
    </div>
    <EditTag
      v-if="editTagBool"
      :tagData="tagData"
      @cancelEdit="handleCancelEdit"
    />
    <SingleTagItem
      v-for="tag in tags"
      :key="tag.tag_id"
      :tagData="tag"
      :checkAll="checkAll"
      @reloadTags="init"
      @editTag="handleEditTag"
      @isChecked="handleIsChecked"
    />
  </div>
</template>

<script>
import api from "@/api";
import SingleTagItem from "./SingleTagItem.vue";
import EditTag from "./EditTag.vue";
export default {
  components: {
    SingleTagItem,
    EditTag,
  },
  props: {
    searchString: {
      type: String,
    },
  },
  data() {
    return {
      tags: [],
      checkedTags: [],
      checkAll: false,
      editTagBool: false,
      tagData: {},
      offset: 0,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      await this.getTags();
      await this.listenForReload();
      await this.listenForString();
      await this.listenForDeleteSelected();
      await this.listenForHandlePagination();
    },
    async getTags() {
      let params = {
        search: this.searchString,
        offset: this.offset,
        limit: 10,
      };
      try {
        const res = await api.getTags(params);
        this.tags = res.data.result;
        this.EventBus.$emit("getTotal");
      } catch (e) {
        console.warn(e);
      }
    },
    async listenForReload() {
      this.EventBus.$on("reloadTags", async () => {
        await this.getTags();
      });
    },
    async listenForHandlePagination() {
      this.EventBus.$on("handlePagination", (data) => {
        console.log(data.page);
        this.offset = data.page * 10 - 10;
        this.getTags()
      });
    },
    handleEditTag(tagData) {
      this.tagData = tagData;
      this.editTagBool = true;
    },
    handleCancelEdit() {
      this.editTagBool = false;
      this.getTags();
    },
    async listenForString() {
      this.EventBus.$on("searchString", (str) => {
        this.getTags(str);
      });
    },
    handleIsChecked(payload) {
      console.log(this.checkedTags);
      if (!payload.checked) {
        for (const [i, el] of this.checkedTags.entries()) {
          if (el.id == payload.id) {
            this.checkedTags.splice(i, 1);
          }
        }
      } else {
        this.checkedTags.push(payload);
      }
    },
    async listenForDeleteSelected() {
      let i = 0;
      this.EventBus.$on("deleteSelected", async () => {
        this.checkedTags.forEach(async (tag) => {
          try {
            let res = await api.deleteTag({
              tag_id: tag.id,
            });
            this.checkedTags.splice(i, 1);
            this.tags.splice(i, 1);
            i++;
            this.openToast(this.$t("adminTags.deleteOk"));
            this.$emit("reloadTags");
          } catch (error) {
            console.warn(error);
            this.customError(this.$t("adminTags.fail"));
          }
        });
      });
    },
    handleCheckAll() {
      this.checkAll = !this.checkAll;
    },
  },
};
</script>

<style scoped lang='scss'>
.tags-wrapper {
  margin: 24px 0 0 0;
  border: 1px solid #dfe1e6;
  .header-controls {
    background: #f4f5f7;
    height: 56px;
    border-bottom: 1px solid #dfe1e6;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px 16px;
    .left {
      display: flex;
      align-items: center;
      justify-content: space-between;
      min-width: 113px;
      .tag-name {
        font-family: Roboto;
        font-style: normal;
        font-weight: bold;
        font-size: 14px;
        line-height: 22px;
        display: flex;
        align-items: center;
        color: #001529;
        // margin: 0px 10px;
      }
      .tagname-wrap {
        display: flex;
        align-items: center;
        .arrows {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          height: 30px;
          span {
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 20px;
            width: 50%;
            height: 50%;
            cursor: pointer;
          }
        }
      }
    }
    .right {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .count-wrap {
        display: flex;
        align-items: center;
        .count {
          font-family: Roboto;
          font-style: normal;
          font-weight: bold;
          font-size: 14px;
          line-height: 22px;
          display: flex;
          align-items: center;
          color: #001529;
        }
        .arrows {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          height: 30px;
          span {
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 20px;
            width: 50%;
            height: 50%;
            cursor: pointer;
          }
        }
      }
      .actions-wrap {
        .actions {
          font-family: Roboto;
          font-style: normal;
          font-weight: bold;
          font-size: 14px;
          line-height: 22px;
          display: flex;
          align-items: center;
          color: #001529;
        }
      }
    }
  }
}
</style>